<app-header-nav
  class="sticky-top"
  [hideProgress]="true"
  [showBody]="false"></app-header-nav>
@if (!isMobileView()) {
  <app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
}
<div
  class="container-terms p-3 py-lg-5"
  [ngClass]="{ 'mobile-view': isMobileView() }">
  @if (!isLoading()) {
    @if (html()) {
      <p class="text-end">
        @if (status()) {
          <app-status-badge
            [value]="status()"
            [department]="statusBadgeDepartments.DOCUMENTS"></app-status-badge>
        }
        <span class="ms-4">Effective date: {{ date() }}</span>
      </p>
      @if (isPrePaidTerms()) {
        <div class="row">
          <div class="col-8">
            <img
              ngSrc="./assets/standard-bank-logo.png"
              width="282"
              height="80"
              class="mb-4 img-fluid"
              alt="Standard Bank" />
          </div>
        </div>
      }
      <div
        [ngClass]="{ 'mobile-html': isMobileView() }"
        [innerHTML]="html()"></div>
      <div class="text-center mb-5">
        <button
          class="btn btn-dark"
          (click)="scrollToTop()">
          Back to Top
        </button>
      </div>
    }
    @if (is404()) {
      <app-page-not-found
        [btnText]="'Go back'"
        [fullPage]="false"></app-page-not-found>
    }
  } @else {
    <app-loader class="my-5"></app-loader>
  }
</div>
